import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleLoginButton from '../components/GoogleLoginButton';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Mensagem de sucesso vinda da tela de reset-password
  const successMessage = location.state?.message || '';

  function redirectAfterLogin(user) {
    const redirectTo = new URLSearchParams(location.search).get('redirectTo');
    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      navigate(user.isAdmin ? '/admin' : '/usuarios', { replace: true });
    }
  }

  async function handleGoogleCredential(credential) {
    setError('');
    try {
      const user = await loginWithGoogle(credential);
      redirectAfterLogin(user);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao entrar com Google.');
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      redirectAfterLogin(user);
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao tentar fazer login.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="page-container form-page">
      <h2>Login</h2>
      <form onSubmit={handleSubmit} className="form-card">
        {successMessage && <div className="alert-success">{successMessage}</div>}
        {error && <div className="alert-error">{error}</div>}
        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </label>
        <label>
          Senha
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </label>
        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
        <div style={{ textAlign: 'center', fontSize: '0.85rem', color: '#888' }}>ou</div>
        <GoogleLoginButton onCredential={handleGoogleCredential} text="signin_with" />
        <Link to="/forgot-password" style={{ textAlign: 'center', fontSize: '0.9rem' }}>
          Esqueceu a senha?
        </Link>
        <p style={{ textAlign: 'center', fontSize: '0.9rem', margin: 0 }}>
          Não tem conta? <Link to="/register">Cadastrar</Link>
        </p>
      </form>
    </main>
  );
}
